module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ccad5b82466a7542b58231b056b7a377.png";